<template>
  <!-- 用户管理 -->
  <div class="treeBigBox">
    <div class="right">
      <div class="searchBox" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
          <div class="inpBox">
            <el-form-item label="用户姓名:" prop="userName">
              <el-input placeholder maxlength="30" v-model="searchFrom.userName"></el-input>
            </el-form-item>
          </div>
          <div class="searchBtnBox">
            <el-form-item>
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addClick">新增</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!--  表格 -->
      <div class="table" :style="{height:h}">
        <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" style="width: 100%" height="100%" center border>
          <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="qiYongClick(scope.row)" v-if="scope.row.tEnableFlag=='0'">启用</el-button>
                <el-button type="text" size="mini" @click="qiYongClick(scope.row)" v-if="scope.row.tEnableFlag=='1'">停用</el-button>
                <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" @click="delFn(scope.row)" v-if="scope.row.isAdmin == 0">删除</el-button>
                <!-- 2022-06-17 夏产品改 注掉发送短信按钮 原因（避免货主密码暴露隐患，本页面发送短信按钮隐藏，开发内容保存，未来如果有需求需要再做添加） -->
                <!-- <el-button type="text" size="mini" @click="sendSms(scope.row)" :disabled='scope.row.sendDisabled'>发送短信</el-button> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column property="tEnableFlag" label="启用状态" width="140">
            <template scope="scope">
              <div>
                {{[ "未启用","已启用"][scope.row.tEnableFlag]}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="用户姓名" width="150" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="userAccount" label="登录账号" width="170" :formatter="emptyFn"></el-table-column>
          <!-- <el-table-column property="enableFlag" label="启用状态" width="140">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.enableFlag=='0'">
                未启用
              </span>
              <span v-else-if="scope.row.enableFlag=='1'">
                已启用
              </span>
            </div>
          </template>
        </el-table-column> -->
          <!-- <el-table-column property="enableFlag" label="启用状态" width="140">
          <template slot-scope="scope">
            {{ '已启用' }}
          </template>
        </el-table-column> -->
          <el-table-column prop="number" width="120" label="用户角色">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="roleNumberClick(scope.row)">{{scope.row.number}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" width="150" label="联系电话" :formatter="emptyFn"></el-table-column>
          <el-table-column property="secondheckFlg" label="登录是否短信验证" width="160">
            <template scope="scope">
              <div>
                {{[ "否","是"][scope.row.secondheckFlg]}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createRelUserName" label="创建人" width="150" :formatter="emptyFn"></el-table-column>
          <el-table-column prop="createTime" min-width="180" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[10,25,50,100]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <!--角色个数查看-->
    <!-- <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="roleNumMark"  width="650px" center>
      <p>{{roleName}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleNumMark = false" size="mini"  type="primary">关闭</el-button>
      </span>
    </el-dialog> -->
    <!--角色个数查看-->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="roleNumMark" width="650px" center>
      <!-- <p>{{roleName}}</p> -->
      <div style="margin: 28px 0 0 0;">
        <h4 class="userTitle">用户角色</h4>
        <el-checkbox-group v-model="checked" style="margin-left:48px" disabled class="check2">
          <el-checkbox v-for="item in Seerole" :key="item.id" :label="item.id">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
              <span>{{item.name}}</span>
            </el-tooltip>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleNumMark = false" size="mini" type="primary">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="userMark" width="930px" class="detail" :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <el-form :inline="true" :model="userForm" ref="userForm" :rules="rules" class="demo-form-inline jiaoyan" label-width="120px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0;">
            <h4 class="userTitle">基础信息</h4>
            <el-form-item label="用户姓名:" prop="userName">
              <el-input placeholder maxlength="30" v-model.trim="userForm.userName" @change="msgchange" :readonly="read" :class="read?'disabled':''"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="mobile">
              <el-input placeholder="" v-number-input.float="0" maxlength="11" v-model.trim="userForm.mobile" @change="msgchange" :readonly="read" :class="read?'disabled':''"></el-input>
            </el-form-item>
            <el-form-item label="用户性别:" prop="userSex">
              <el-radio-group v-model="userForm.userSex" :disabled="read" :class="read?'disabled':''">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="登录账号:" prop="userAccount">
              <el-input placeholder maxlength="30" v-model.trim="userForm.userAccount" :readonly="read" :class="read?'disabled':''"></el-input>
            </el-form-item>
            <el-form-item label="用户座机:" prop="tel">
              <el-input placeholder maxlength="15" v-model.trim="userForm.tel" :readonly="read" :class="read?'disabled':''"></el-input>
            </el-form-item>
             <el-form-item label="数据权限:" prop="dataLevel" class="inpBox1">
                <el-select  v-model="userForm.dataLevel" placeholder="请选择" >
                  <template  v-for="item in dengJiOptions">
                    <el-option  :key="item.id"  :label="item.name" :value="item.id"  ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            <el-form-item label="身份证号:" prop="identityCard">
              <el-input placeholder maxlength="18" v-model.trim="userForm.identityCard" :readonly="read" :class="read?'disabled':''"></el-input>
            </el-form-item>
            <el-form-item label="登录是否短信验证:" prop="secondheckFlg" label-width="176px">
              <el-radio-group v-model="userForm.secondheckFlg">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <hr>
            <div style="margin: 28px 0 0 0;">
              <h4 class="userTitle">用户授权</h4>
              <p v-if="userType.length==0" style="text-align:center">暂无数据</p>
              <el-form-item prop="roleIds">
                <el-checkbox-group v-model="userForm.roleIds" style="margin-left:48px">
                  <el-checkbox v-for="item in userType" :key="item.id" :label="item.id">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <hr>
            <div style="margin: 28px 0 0 0;">
              <h4 class="userTitle">个性化配置</h4>
              <ul class="box1">
                <p v-if="shuxingList.length==0" style="text-align:center">暂无数据</p>
                <li class="boxItem" v-for="item in shuxingList" :key="item.attributeFlag">

                  <!-- <div class="biaotou">
                            <el-tooltip class="item" effect="dark" :content="item.attributeRemark" placement="top-start">
                             <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="item.attributeName" placement="top-start">
                             <span class="title1">{{item.attributeName}}</span>
                            </el-tooltip>
                          </div> -->
                  <el-tooltip class="item" effect="dark" :content="item.attributeRemark" placement="top-start">
                    <div class="biaotou">
                      <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                      <span class="title1">{{item.attributeName}}</span>
                    </div>
                  </el-tooltip>
                  <div class="juese">
                    <el-radio-group v-model="item.attributeDefault" v-if="item.attributeType==2">
                      <!-- <el-radio label="0">是</el-radio>
                            <el-radio label="1">否</el-radio> -->
                      <el-radio v-for="item1 in item.optionsList" :key="item1.index" :label="item1.optionValue">
                        <el-tooltip class="item" effect="dark" :content="item1.optionName" placement="top-start">
                          <span>{{ item1.optionName }}</span>
                        </el-tooltip>
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <el-input style="width: 450px" v-if="item.attributeType==1" type="textarea" v-model="item.attributeDefault"></el-input>
                  <el-checkbox-group v-model="item.attributeArr" v-if="item.attributeType==3" class="check1">
                    <el-checkbox v-for="item in item.optionsList" :key="item.optionValue" :label="item.optionValue">
                      <el-tooltip class="item" effect="dark" :content="item.optionName" placement="top-start">
                        <span>{{item.optionName}}</span>
                      </el-tooltip>
                    </el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userMark = false" size='mini'>取消</el-button>
        <el-button type="primary" size='mini' @click="saveFn()" v-show="addBtnShow">保 存</el-button>
        <el-button type="primary" size='mini' @click="changeEdit()" v-show="changeBtnShow">修 改</el-button>
      </span>
    </el-dialog>
    <!--开通短信-->
    <el-dialog title="提示" :visible.sync="msgMark" class="detail" :close-on-click-modal="false" :close-on-press-escape="false" width="520px" center @close="closeDialog1">
      <el-form :inline="true" :model="msgForm" ref="msgForm" class="demo-form-inline jiaoyan" label-width="180px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0;">
            <el-form-item label="企业名称:" prop="tenantName" style="width:490px">
              <span>{{msgForm.tenantName}}</span>
            </el-form-item>
            <el-form-item label="访问地址:" prop="address" style="width:360px">
              <span>{{msgForm.address}}</span>
            </el-form-item>
            <el-form-item label="用户姓名:" prop="userName" style="width:360px">
              <span>{{msgForm.userName}}</span>
            </el-form-item>
            <el-form-item label="登录账号:" prop="userAccount" style="width:360px">
              <span>{{msgForm.userAccount}}</span>
            </el-form-item>
            <el-form-item label="登录密码:" prop="password" style="width:360px">
              <span>{{msgForm.password}}</span>
            </el-form-item>
            <el-form-item label="以上信息是否短信告知:" prop="isSend" style="width:360px">
              <el-radio v-model="msgForm.isSend" label="0">是</el-radio>
              <el-radio v-model="msgForm.isSend" label="1">否</el-radio>
            </el-form-item>
            <el-form-item label="手机号:" prop="mobile" v-if="msgForm.isSend == 0" style="width:360px">
              <el-input placeholder="" v-number-input.float="0" maxlength="11" v-model.trim="msgForm.mobile"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="msgMark = false">取消</el-button>
        <el-button type="primary" @click="msgSave()">确定</el-button>
      </span>
    </el-dialog>
    <sendSmsDialog v-if="sendSmsVisible" :sendSmsVisible.sync='sendSmsVisible' :userId='userId'></sendSmsDialog>
  </div>
</template>

<script>
import {
  sUserList, // 用户列表
  sUserCheckUser,
  roleListByTenant, // 用户授权
  sUserAdd, // 添加
  sUserUpdate, // 修改
  updateEnableFlag, // 停/启用
  sUserDelete, // 删除
  roleByUserId, // 用户角色
  sendMessage, // 短信
  sAttributeObjRelList // 属性配置
} from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat, arrChaJi } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import sendSmsDialog from '@/views/newCrm/components/sendSmsDialog.vue'
export default {
  components: {
    sendSmsDialog
  },
  props: {
    basicData: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data () {
    return {
      checked: false,
      Seerole: [],
      Status: '',
      shuxingList: [],
      msgForm: {
        isSend: '1'
      },
      msgMark: false,
      read: false,
      userType: [],
      resetPasswordFlag: false, // 重置密码
      checkList: [],
      loading: false,
      // 添加用户
      userForm: {
        userSex: '1',
        secondheckFlg: '0',
        roleIds: []
      },
      roleName: '',
      userMark: false,
      addBtnShow: true, // 新增页面保存按钮
      changeBtnShow: false, // 修改页面保存按钮
      title: '',
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      // 新增验证
      rules: {
        userAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userSex: [
          { required: true, message: '请选择用户性别', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        userName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' }
        ],
        dataLevel: [
          { required: true, message: '请选择数据权限等级', trigger: 'blur' }
        ],
        secondheckFlg: [
          { required: true, message: '请选择登录是否开启短信验证', trigger: 'blur' }
        ]
      },
      oldRoleList: [],
      msg: [],
      addFrom: {},
      // 角色个数
      roleNumMark: false,
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P007B001', '000P007B002', '000P007B003',
        '000P007B004', '000P007B005', '000P007B006',
        '000P007B007', '000P007B008', '000P007B009'],
      sendSmsVisible: false,
      userId: '',
      // 启用
      qiYongId: '',
      qiYongFlg: '',
      dengJiOptions: [
        { name: '查看集团及以下数据', id: 1 },
        { name: '查看分子公司及以下数据', id: 2 },
        { name: '查看部门及以下数据', id: 3 },
        { name: '查看分子部门及以下数据', id: 4 },
        { name: '查看岗位及以下数据', id: 5 },
        { name: '查看个人及以下数据', id: 6 }
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/pingTaiYongHu')
    // console.log(this.basicData + 'Data')
    this.tenantCode = this.basicData.tenantCode
    this.useTenantCode = this.basicData.useTenantCode
    this.getList(this.searchFrom)
    // 用户授权
    roleListByTenant({ tenantCode: this.tenantCode, useTenantCode: this.useTenantCode, type: 3 }).then(res => {
      this.userType = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 208 + 'px'
  },
  methods: {
    // 添加模板
    addClick () {
      this.title = '添加用户'
      this.userMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.read = false
      sAttributeObjRelList({
        targetType: 1, // '目标对象类型(1.用户，2.租户，3.客户)',
        tenantCode: this.tenantCode,
        useTenantCode: this.useTenantCode,
        sceneIdList: [4]
        // targetCode: this.rowData.customerCode,
        // rId: this.rowData.rId
      }).then(res => {
        this.shuxingList = res
        this.shuxingList.forEach((item, index) => {
          if (item.attributeType == 3 && item.attributeDefault) {
            this.$set(this.shuxingList[index], 'attributeArr', item.attributeDefault.split(','))
          } else {
            this.$set(this.shuxingList[index], 'attributeArr', [])
          }
        })
      })
    },
    msgchange () {
      if (this.userForm.userName && this.userForm.mobile) {
        // console.log(this.useTenantCode + 'shiyong');
        sUserCheckUser({ userName: this.userForm.userName, mobile: this.userForm.mobile, tenantCode: this.tenantCode, useTenantCode: this.useTenantCode }).then(res => {
          this.msg = res.user
          // console.log(res.status);
          if (res.status == 2) {
            this.$message.warning('该用户已存在！')
            this.userForm.userName = ''
            this.userForm.mobile = ''
          } else if (res.status == 1) {
            // this.$message.warning("该用户已存在！")
            this.userForm.userName = this.msg.userName
            this.userForm.mobile = this.msg.mobile
            this.userForm.userSex = this.msg.userSex
            this.userForm.userSex = this.userForm.userSex.toString()
            this.userForm.userAccount = this.msg.userAccount
            this.userForm.tel = this.msg.tel
            this.userForm.identityCard = this.msg.identityCard
            this.userForm.id = this.msg.id
            this.read = true
          }
          this.Status = res.status
          // console.log(this.Status);
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },

    // 添加保存
    saveFn () {
      // if (this.userForm.roleIds.length == 0) {
      //    return this.$message.error('必须选择至少一个用户授权')
      // }
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.$set(this.userForm, 'tenantCode', this.tenantCode)
          this.$set(this.userForm, 'useTenantCode', this.useTenantCode)
          this.$set(this.userForm, 'targetType', 1)
          this.shuxingList.forEach((item, index) => {
            if (item.attributeType == 3) {
              this.$set(this.shuxingList[index], 'attributeDefault', item.attributeArr.toString())
            }
          })
          this.$set(this.userForm, 'attributeList', this.shuxingList)
          sUserAdd(this.userForm).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            // console.log(this.Status+'添加');
            if (this.Status != 1) {
              this.msgMark = true
              this.msgForm = res
              this.$set(this.msgForm, 'isSend', '1')
            }
            this.userMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    msgSave () {
      if (this.msgForm.isSend == 0) {
        sendMessage(this.msgForm).then(res => {
          this.$message({
            message: '发送成功',
            type: 'success'
          })
          this.msgMark = false
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
      } else {
        this.msgMark = false
      }
    },
    // 查询接口
    getList (searchFrom) {
      this.searchFrom.tenantCode = this.tenantCode
      this.searchFrom.useTenantCode = this.useTenantCode
      this.searchFrom.isAdmin = 0
      sUserList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 修改
    editFn (row) {
      this.title = '修改用户'
      this.userMark = true
      this.addBtnShow = false
      this.changeBtnShow = true
      this.userForm = { ...row }
      if (this.userForm.userSex) {
        this.$set(this.userForm, 'userSex', this.userForm.userSex.toString())
      }
      this.$set(this.userForm, 'secondheckFlg', this.userForm.secondheckFlg.toString())
      let roleIds = []
      this.userForm.roleIds.split(',').forEach(element => {
        roleIds.push(Number(element))
      })
      this.userForm.roleIds = roleIds
      this.oldRoleList = roleIds
      this.read = true
      this.$set(this.userForm, 'userCode', this.userForm.userCode)
      sAttributeObjRelList({
        targetType: 1, // '目标对象类型(1.用户，2.租户，3.客户)',
        tenantCode: this.tenantCode,
        useTenantCode: this.useTenantCode,
        sceneIdList: [4],
        targetCode: this.userForm.userCode
        // rId: this.rowData.rId
      }).then(res => {
        this.shuxingList = res

        this.shuxingList.forEach((item, index) => {
          if (item.attributeType == 3 && item.attributeDefault) {
            this.$set(this.shuxingList[index], 'attributeArr', item.attributeDefault.split(','))
          } else {
            this.$set(this.shuxingList[index], 'attributeArr', [])
          }
        })
      })
    },
    // 修改保存
    changeEdit () {
      // if (this.userForm.roleIds.length == 0) {
      //   return this.$message.error('必须选择至少一个用户授权')
      // }
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let data = {}
          data.addRoles = arrChaJi(this.userForm.roleIds, this.oldRoleList, 1)
          data.delRoles = arrChaJi(this.userForm.roleIds, this.oldRoleList, 2)
          this.$set(this.userForm, 'addRoles', data.addRoles)
          this.$set(this.userForm, 'delRoles', data.delRoles)
          this.$set(this.userForm, 'tenantCode', this.tenantCode)
          this.$set(this.userForm, 'useTenantCode', this.useTenantCode)
          this.$set(this.userForm, 'targetType', 1)
          this.shuxingList.forEach((item, index) => {
            if (item.attributeType == 3) {
              this.$set(this.shuxingList[index], 'attributeDefault', item.attributeArr.toString())
            }
          })
          this.$set(this.userForm, 'attributeList', this.shuxingList)
          this.$set(this.userForm, 'userCode', this.userForm.userCode)
          sUserUpdate(this.userForm).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.userMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sUserDelete({ id: row.id, tenantCode: this.tenantCode, useTenantCode: this.useTenantCode }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查询
    searchFn () {
      // this.searchFrom.type = 3
      this.getList(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 点击停用/启用
    qiYongClick (row) {
      this.qiYongId = row.id
      this.qiYongFlg = row.tEnableFlag
      if (this.qiYongFlg == '0') {
        this.qiYongFlg = '1'
      } else if (this.qiYongFlg == '1') {
        this.qiYongFlg = '0'
      }
      this.getQiYong()
    },
    // 启用接口
    getQiYong () {
      this.$confirm('是否执行此操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        updateEnableFlag({
          id: this.qiYongId,
          tEnableFlag: this.qiYongFlg,
          tenantCode: this.tenantCode,
          useTenantCode: this.useTenantCode
        }).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        }).catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error'
          })
        })
      }).catch(() => {

      })
    },

    // 点击角色个数查看
    // roleNumberClick (row) {
    //   this.roleNumMark = true
    //   this.title = '查看角色'
    //   roleByUserId({
    //     userId: row.id
    //   }).then(res => {
    //     let roleList = []
    //     res.map(element => {
    //       roleList.push(element.name)
    //     })
    //     this.roleName = roleList
    //     this.roleName = this.roleName.toString()
    //   }).catch(err => {
    //   })
    // },
    // 点击角色个数查看
    roleNumberClick (row) {
      this.roleNumMark = true
      this.title = '查看角色'
      roleByUserId({
        userId: row.id,
        useTenantCode: this.useTenantCode,
        tenantCode: this.tenantCode
      }).then(res => {
        this.Seerole = res
      }).catch(err => {
      })
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.$refs.userForm.clearValidate()
      this.userForm = {
        userSex: '1',
        secondheckFlg: '0',
        roleIds: []
      }
    },
    closeDialog1 () {
      this.msgForm = {
        isSend: '1'
      }
    },
    // 发送短信
    sendSms (row) {
      this.sendSmsVisible = true
      this.userId = row.id
      this.$set(row, 'sendDisabled', true)
      setTimeout(() => {
        this.$set(row, 'sendDisabled', false)
      }, 60000)
    }
  }

}
</script>

<style scoped lang='less'>
.disabled /deep/.el-input__inner {
  background: #dcedff;
}
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor {
  width: 350px !important;
}
.addinpBox .el-input {
  width: 210px;
}
.demo-form-inline .el-form-item {
  margin-bottom: 17px !important;
}

.userTitle {
  font-size: 16px;
  margin-left: 20px;
  border-left: 3px solid #0e6fec;
  padding-left: 8px;
}
.treeBigBox {
  height: 100%;
  display: flex;
}
.treeBox {
  text-align: center;
  padding: 20px 0 0 20px;
}
.title {
  width: 100%;
  height: 36px;
  background: #d8e3f8;
  display: flex;
  align-items: center;
  margin-top: -12px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian {
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right {
  flex: 1;
  width: 75%;
}
.box {
  width: 20%;
  border-right: 1px dashed #ddd;
}
/deep/.el-tree-node__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box1 {
  font-size: 14px;
  padding: 0px 20px;
  .boxItem {
    display: flex;
    align-items: center;
    margin: 28px 0;
    padding-bottom: 28px;
    border-bottom: 1px dashed #ddd;
    .title1 {
      display: inline-block;
      // width: 200px;
      width: 260px;
      margin-right: 25px;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    margin-bottom: 6px;
  }
  .fa {
    font-size: 18px;
    color: #0b4fd6;
    margin-right: 8px;
  }
}
/deep/.el-checkbox__label {
  display: inline;
}
/deep/ .el-checkbox {
  color: #606266;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 247px;
}
/deep/.el-checkbox__label  {
  display: inline;
  padding-left: 10px;
  line-height: 28px;
  font-size: 14px;
}
.check1 /deep/.el-checkbox {
  color: #606266;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 132px;
}
.check1 /deep/.el-checkbox__label  {
  display: inline;
  padding-left: 10px;
  line-height: 28px;
  font-size: 14px;
}
.check2 /deep/ .el-checkbox__inner {
  display: none;
  width: 0;
}
/deep/.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: black;
  cursor: not-allowed;
}
.biaotou {
  display: flex;
  flex-direction: row;
}
.juese .el-radio,
.el-radio__input {
  line-height: 2;
  outline: 0px;
  white-space: nowrap;
}
.juese /deep/.el-radio {
  color: #606266;
  cursor: pointer;
  // margin-right: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 132px;
}
</style>
